export const imagePathConcerts = '/concerts';

export const getConcertImagePath = (seed: string | number) => {
  const hash = Array.from(String(seed)).reduce(
    (value, character) => (value * 31 + character.charCodeAt(0)) >>> 0,
    0
  );

  return `${imagePathConcerts}/rsc-${(hash % 6) + 6}.jpg`;
};
